import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import {Material} from '../../../shared/classes/Material'
import { Location } from '@angular/common';
import * as moment from 'moment';
import { UploadmaterialComponent } from 'src/app/shared/components/uploadmaterial/uploadmaterial.component';
import { Observable, Subject, of } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { InwardService } from 'src/app/shared/services/inward.service';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import {InwardStatus} from 'src/app/Enums/inwardEnum';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import { read, utils } from 'xlsx';
import { GraphData } from 'src/app/shared/classes/grphData';
import { City, Office } from 'src/app/shared/classes/users';
import { UsersService } from 'src/app/shared/services/users.service';
import { city } from '../../../shared/classes/city';
import { MasterService } from 'src/app/shared/services/master.service';
import { UploadMaterialComponent } from '../../upload-material/upload-material.component';
import { ModalSize } from 'src/app/Enums/usersFilterEnums';
import { FileService } from 'src/app/shared/services/file.service';

@Component({
  selector: 'app-inward-reg',
  templateUrl: './inward-reg.component.html',
  styleUrls: ['./inward-reg.component.less']
})
export class InwardRegComponent implements OnInit {
  dateInputData: any = {};
  public materialList:Material[] = [];
  previousValidReturnDate: Date;
  fromtimepickervalue: Date = new Date();
  totimepickervalue: Date = new Date();
  fTime: Date = new Date;
  tTime: Date = new Date;
  fromtimevalue: any;
  totimevalue: any;
  modalRef: BsModalRef;
  data:any;
  isValidTime: boolean = true;
  transactionMasterData : any;
  ReturnSelected : Number;
  nameNotInList : string = '';
  flag: boolean;
  broughtFromList : [] = [];
  selectedValue?: string;
  selectedOption: any;
  isSpinning: boolean;
  showRegButton: boolean = true;
  msstep: number = 1;
  public graphData: GraphData[];
  // validation Variables
  onChangeRegType : boolean = false;
  // onChangebrFrom : boolean = false;
  onChangebrFrom : boolean = true;
  public ClientName: Array<any> = [];
  InwardStatus = InwardStatus;
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  mstep: number = 1;
  typeaheadRequestorLoading: boolean;
  requestorNameChanged: boolean = false;
  Department: string;
  EmployeeFirstName: string;
  EmployeeLastName: string;
  EmployeeFullName: string;
  EmployeeAlias: string;
  EmployeeEmail: string;
  noResultTravelerName: boolean;
  travellerNameArray: any[];
  public cityData:City[];
  CitySelected:number;
  OfficeSelected:number;
  selectedCityId:Array<any>=[];
  MasterList:any;
  public officeData: Office[];
  CityDetails:city;
  OfficeDetails:Office;
  OfficeName:any;
  requestorNameDataSource: Observable<any>;
  debounceTimerSearchClient:any;
  debounceTimerTravellerNameSearch:any;
  @ViewChild('fromtime') fromtime: ElementRef;
  @ViewChild('totime') totime: ElementRef;
  @ViewChild('inwardregform') inwardregfrom : NgForm;
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string }[] = [];
  showUploadMaterial: boolean = false;
  constructor(private location: Location, private modalService: BsModalService,private _dataContextService: DataContextService,
    private httpClient : HttpClient,private userService: UsersService,
    private toast: ToastrService,private loaderService: LoaderService,private inwardService: InwardService,
    private trackeromnitureservice:TrackerOmnitureService,private _masterService: MasterService,private fileService: FileService) {
      this.service_URL = ConstantsService;
      this.OfficeDetails=new Office();
    }

  ngOnInit() {
    this.fileService.files$.subscribe(files => {
      this.attachedFiles = files.filter(file => file.requestType === 'Inward');
    });
    this.fileService.clearFiles();
    // console.log(this.ReturnSelected);
    this.dateInputData.EndDate = new Date();
    this.flag= false;
    this.onTravellerNameSeach();
    this.isSpinning = false;
    this.fromtimevalue = this.GetTimeForDates(new Date);
    this.totimevalue = this.GetTimeForDates(new Date);
    
    // Set Registration Date minimum to today (no past dates) and maximum to 5 working days from today
    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.maxDate = this.addWorkingDays(new Date(), 5);
    this.dateInputData.StartDate = new Date();

    // Set Return Date minimum to same day as registration date and maximum to 168 days from registration date
    this.dateInputData.FromMinToDate = new Date();
    this.dateInputData.maxToDate = new Date();
    this.dateInputData.maxToDate.setDate(this.dateInputData.maxToDate.getDate() + 168);
    this.previousValidReturnDate = new Date();
    
    //Getting Transaction Master Data into Dropdowns
    this.getRequestType();
    this.getBroughtFromList();
    this.getInwardMasterData();
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('inward-reg',username);
    this.trackeromnitureservice.trackPage("pageView");

    
  }

  showButton(){
    if(this.onChangeRegType && this.onChangebrFrom && this.inwardregfrom.valid && this.OfficeName  && this.CitySelected && this.materialList.length > 0){
      // Material List Validation
      if(this.materialList.length > 0){
        var flag = false;
        for(var i=0;i<this.materialList.length;i++){
          flag = false;
          var task = this.materialList[i];
          if(task.Name == '' || task.Quantity == null || task.Quantity == 0){
            flag = true;
            break;
          }
        }
        if(flag){
          return true;
        }
      }
      return false;
    }
    return true;
  }

  fromTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.fTime).format('DD/MM/YYYY') + ', ' + this.fromtime.nativeElement.value;
    }
    this.fTime = new Date(input);
    this.fromtimevalue = this.GetTimeForDates(this.fTime);
  }
  
  toTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.tTime).format('DD/MM/YYYY') + ', ' + this.totime.nativeElement.value;
    }
    this.tTime = new Date(input);
    this.totimevalue = this.GetTimeForDates(this.tTime);
    // console.log(this.totimevalue);

    // Second variable with 12 hour format time as a string
    var twelveHourFormatTime = this.totimevalue;

    // Split the time into hours and minutes
    var [hourStr, minuteStr] = twelveHourFormatTime.split(':');
    var hours = parseInt(hourStr, 10);
    var minutes = parseInt(minuteStr, 10);

    // If the time is in PM, add 12 to the hours
    if (twelveHourFormatTime.includes('PM') && hours !== 12) {
      hours += 12;
    }

    // Set the hours and minutes on the current date
    this.dateInputData.EndDate.setHours(hours);
    this.dateInputData.EndDate.setMinutes(minutes);

    // var options = { timeZone: 'Asia/Kolkata' };
    // this.dateInputData.EndDate = this.dateInputData.EndDate.toLocaleString('en-US', options);

    // console.log(this.dateInputData.EndDate);
  }

  GetTimeForDates(date: Date): string {
    let time = moment(date).format("hh:mm A");
    return time;
  }

  addMaterial(){
    this.materialList.push(new Material())
    //console.log(this.materialList)
  }

  removeMaterial(index:number){
    if(index > -1){
      this.materialList.splice(index,1);
    }
  }

  OnchangeReturnType(event){
    // console.log(event);
    // console.log(this.ReturnSelected);
    this.onChangeRegType = true;
  }

  //Function to get the Office and City Master Data.
  getInwardMasterData() {
   this._dataContextService.get<any>(this.service_URL.Master.InwardMasterData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      this.MasterList = res;
      this.cityData = this.MasterList.cityList;
      this.officeData = this.MasterList.officeList; 
    },
    (err) => {
      console.log(err);
    })
  }

  selectCity(){
    
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected
    }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);

  }

  OnOfficeChange(val){
    this.OfficeName=val;
  }

  OnchangeCity(event) {
    
    if(!this.CitySelected)
    {
      var tempo : Array<any>=[];
      var temp : Array<any>=[];
      let i=0;
      for(i=0;i<this.selectedCityId.length;i++){
        tempo= this.MasterList.office.filter((item) => {
          return item.cityId === this.selectedCityId[i].cityId
        });

        // temp.concat(tempo);
         temp = temp.concat(tempo);
  
      }
      this.officeData =   temp.sort((item1,item2)=>(item1.displayName < item2.displayName)?-1:1);
      
    }
   
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected
      }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
    }

  uploadMaterial()
  {
    this.modalRef = this.modalService.show(UploadmaterialComponent)
    // console.log(this.data);
    this.modalRef.content.event.subscribe(res => {
    //  console.log(res);
    });
   // this.modalRef.afterClosed().subscribe()
  }

  isValid(event: any) {
    this.isValidTime = event;
  }

//   handleImport($event: any) {
//     const files = $event.target.files;
//     if (files.length) {
//         const file = files[0];
//         const reader = new FileReader();
//         reader.onload = (event: any) => {
//             const wb = read(event.target.result);
//             const sheets = wb.SheetNames;

//             if (sheets.length) {
//                 const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
//                 this.materialList = rows;
//             }
//         }
//         reader.readAsArrayBuffer(file);
//     }
// }

  addInwardRequest(requestorNameval,dcVal,brfrom,remarks){
    if(this.inwardregfrom.valid && this.ReturnSelected != undefined){
      let PrepareObj = {
        DCNumber : dcVal,
        RecipientEmailId : this.EmployeeEmail,
        CityId : this.CitySelected,
        OfficeId : this.OfficeName,
        RecipientName : requestorNameval,
        RegistrationDateTime : this.dateInputData.StartDate.toISOString(),
        ReturnDateTime : this.ReturnSelected == InwardStatus.NonReturnable ? null : this.dateInputData.EndDate.toISOString(),
        Remarks : remarks.length > 0 ? remarks : null,
        SerialNumber : 'IR',
        // BroughtFromId : this.selectedOption === undefined ? 0 : this.selectedOption.broughtFromId,
        BroughtFromId : 0,
        ReceivedById : 0,
        // BroughtFromName : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
        // BroughtFrom : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
        BroughtFromName : brfrom.toUpperCase(),
        BroughtFrom : brfrom.toUpperCase(),
        ReceivedBy : '-',
        ReceivedByName : '-',
        ReceivedOn : new Date().toISOString(),
        RegistrationType : this.ReturnSelected,
        IsActive : true,
        StatusId : InwardStatus.Created,
        CreatedBy: localStorage.getItem('email'),
        UpdatedBy: localStorage.getItem('email'),
        materialList : this.materialList,
        attachedFiles: this.attachedFiles     
      }
  
     // this.attachedFiles = [];
  
      this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.AddInwardRequest, PrepareObj)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // this.modalRef.hide();
          if(res > 0){
            this.loaderService.show();
            this.inwardService.refreshwithFilters.next();
            this.toast.success("Registration successfully created");
            this.location.back();
          }
          else{
            // console.log(res);
            this.toast.error("Request could not be added !");
          }
        },
        (error) => {
          console.log(error);
          this.toast.error("Request could not be added !");
        });
    }
    else{
      this.toast.error("Please add the missing details !");
    }
  }
  
  GetData(){
    // console.log(this.materialList);
  }

  goBack() : void{
    this.location.back();
  }

  onSelect(event: TypeaheadMatch): void {
    this.selectedOption = event.item;
    // console.log(this.selectedOption);
    // console.log(this.selectedValue);
  }

  onChangename(event){
    this.nameNotInList = event;
    this.onChangebrFrom = true;
  }

  getBroughtFromList(){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.BroughtFrom)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      // console.log(res);
      this.broughtFromList = res;
    })
  }

  changeRequestorTypeaheadLoading(e: boolean): void {
    if (this.requestorNameChanged != false) {
      this.typeaheadRequestorLoading = e;
    }
  }

  onTravellerNameSeach() {
      this.requestorNameDataSource = Observable.create((observer: any) => {
        clearTimeout(this.debounceTimerTravellerNameSearch);

        let txt = this.EmployeeFullName;
        let url = this.service_URL.Users.graphApi;
        let param = new HttpParams ().set("key",txt);
         
        this.debounceTimerTravellerNameSearch = setTimeout(() => {
          this._dataContextService.GetwithValues<any>(url, null,param)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(result => {
              this.travellerNameArray = result;
              observer.next(result);
            },
            (err) => {
              console.log(err);
            }
          );   
        }, 300);
        this.requestorNameChanged = true;
      }).pipe(mergeMap((token: string) => this.getRequestorNamesData(token)));
  }

  requestorNameOnSelect(e: TypeaheadMatch): void {   
    this.EmployeeFullName = e.item.displayName;  
  }

  typeaheadTravelerNoResults(event: boolean): void {   
    this.EmployeeFirstName = undefined;
    this.EmployeeLastName = undefined;
    this.EmployeeAlias = undefined    
    this.Department == undefined
    this.noResultTravelerName = event;

  }

  getRequestorNamesData(token: string): Observable<any> {

    let query = new RegExp(token, 'ig');
    return of(
      this.travellerNameArray.filter((obj: any) => {
        let hostObj = query.test(obj.displayName)
        return obj;
      })
    );
  }

  searchClient(val : string) {
    clearTimeout(this.debounceTimerSearchClient);
    
    if (val.length > 2) {
      this.flag = true;
      this.isSpinning = true;    
      let url = this.service_URL.Users.graphApi + '?key=' +val;
      
      this.debounceTimerSearchClient = setTimeout(() => {    
        this._dataContextService.get<any>(url)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(res => {
            this.graphData = res;
            this.ClientName = this.graphData;
            this.isSpinning = false;
          },
          (err) => {
            console.log(err);
            this.isSpinning = false;
          })
      }, 300);    
    }
    else {
      this.isSpinning = false;
    }
  }

   //Will trigger after selecting the user from dropdown
   onselectClient(ClientObj) { 
    this.flag = false;
    this.isSpinning = false;
    this.EmployeeEmail = ClientObj.mail.toLowerCase(); 
  }


  getRequestType(){
    this._dataContextService.get<any>(this.service_URL.OperationsMasterData.GetTransactionData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      this.transactionMasterData = res.filter((item)=>
      {  
        return item.category == 'inwardrequesttype'
      });
      // console.log(this.transactionMasterData);
    })
  }

  // Helper function to add working days (excluding weekends)
  addWorkingDays(date: Date, daysToAdd: number): Date {
    const result = new Date(date);
    let addedDays = 0;
    
    while (addedDays < daysToAdd) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }
    
    return result;
  }

  // Validate registration date is within allowed range
  validateRegistrationDate(selectedDate: Date): void {
    if (!selectedDate) return;
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    
    const maxDate = this.addWorkingDays(new Date(), 5);
    maxDate.setHours(0, 0, 0, 0);
    
    if (selected < today) {
      this.toast.error('Registration date cannot be in the past');
      this.dateInputData.StartDate = new Date();
    } else if (selected > maxDate) {
      this.toast.error('Registration date cannot be more than 5 working days from today');
      this.dateInputData.StartDate = new Date();
    }
    
    // Update return date constraints when registration date changes
    this.updateReturnDateConstraints(this.dateInputData.StartDate);
  }

  // Update return date min/max based on registration date
  updateReturnDateConstraints(registrationDate: Date): void {
    if (!registrationDate) return;
    
    // Return date minimum is the same day as registration date
    this.dateInputData.FromMinToDate = new Date(registrationDate);
    
    // Return date maximum is 168 days from registration date
    const maxReturnDate = new Date(registrationDate);
    maxReturnDate.setDate(maxReturnDate.getDate() + 168);
    this.dateInputData.maxToDate = maxReturnDate;
    
    // If current return date is before new minimum, reset it
    if (this.dateInputData.EndDate && this.dateInputData.EndDate < registrationDate) {
      this.dateInputData.EndDate = new Date(registrationDate);
      this.previousValidReturnDate = new Date(registrationDate);
    }
  }

  // Validate return date is within allowed range
  validateReturnDate(selectedDate: Date): void {
    if (!selectedDate || !this.dateInputData.StartDate) return;
    
    // Initialize previousValidReturnDate if not set
    if (!this.previousValidReturnDate) {
      this.previousValidReturnDate = new Date(this.dateInputData.StartDate);
    }
    
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    
    // Return date minimum should be the registration date (not today)
    const minDate = new Date(this.dateInputData.StartDate);
    minDate.setHours(0, 0, 0, 0);
    
    const maxDate = new Date(this.dateInputData.maxToDate);
    maxDate.setHours(0, 0, 0, 0);
    
    if (selected < minDate) {
      this.toast.error('Return date cannot be before the registration date');
      // Reset to previous valid date (e.g., if was 13, reset back to 13)
      this.dateInputData.EndDate = new Date(this.previousValidReturnDate);
    } else if (selected > maxDate) {
      this.toast.error('Return date cannot be more than 168 days from the registration date');
      // Reset to previous valid date (e.g., if was 13, reset back to 13)
      this.dateInputData.EndDate = new Date(this.previousValidReturnDate);
    } else {
      // Validation passed, update the stored valid date
      this.previousValidReturnDate = new Date(selectedDate);
    }
  }

  increase(num: any){
    this.materialList[num].Quantity++;
  }

  decrease(num: any){
    if(this.materialList[num].Quantity != 0){
      this.materialList[num].Quantity--;
    }
  }
  UploadMaterial(){
     
      this.modalRef = this.modalService.show(UploadMaterialComponent,{
        initialState : {
         requestType: 'Inward'   
        }
      })
      this.modalRef.setClass(ModalSize.Large);
      if (this.modalRef && this.modalRef.content && this.modalRef.content.event) {
        this.modalRef.content.event.subscribe(res => {
          console.log(res);
          this.showUploadMaterial = true;
        });
    } else {
        console.error('modalRef or modalRef.content.event is not defined');
    }
      
  
    }
    deleteFile(index: number): void {
      this.fileService.removeFile(index);
    }
    closeUploadMaterial(): void {
      this.showUploadMaterial = false;
     
    }
    handleFileData(fileData: { name: string, type: string, data: string | ArrayBuffer, requestType: string}): void {
      this.attachedFiles.push(fileData);
    }
}
